export default __webpack_public_path__ + "static/favicon-ba473beda453e5c06f928e1395638594.png";